/* Sutrayan one-shot scroll reveals. Content stays visible unless setup succeeds. */
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduce || !('IntersectionObserver' in window)) return;

  var observer;

  function assignGroup(group) {
    var children = group.children;
    var revealIndex = 0;
    for (var i = 0; i < children.length; i++) {
      if (!children[i].matches('[data-sy-reveal], .sy-reveal')) continue;
      if (!children[i].style.getPropertyValue('--sy-reveal-index')) {
        children[i].style.setProperty('--sy-reveal-index', Math.min(revealIndex, 5));
      }
      revealIndex += 1;
    }
  }

  function assignStagger(scope) {
    if (scope.nodeType === 1 && scope.matches('[data-sy-reveal-stagger], .sy-reveal--stagger')) {
      assignGroup(scope);
    }
    var groups = scope.querySelectorAll('[data-sy-reveal-stagger], .sy-reveal--stagger');
    for (var i = 0; i < groups.length; i++) {
      assignGroup(groups[i]);
    }
  }

  function observe(item) {
    if (item.classList.contains('is-revealed') || item.hasAttribute('data-sy-reveal-observed')) return;
    item.setAttribute('data-sy-reveal-observed', '');
    observer.observe(item);
  }

  function scan(scope) {
    var container = scope && scope.querySelectorAll ? scope : doc;
    assignStagger(container);
    if (container.nodeType === 1 && container.matches('[data-sy-reveal], .sy-reveal')) observe(container);
    var items = container.querySelectorAll('[data-sy-reveal], .sy-reveal');
    for (var i = 0; i < items.length; i++) {
      observe(items[i]);
    }
  }

  try {
    observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting || entries[i].intersectionRatio < 0.149) continue;
        entries[i].target.classList.add('is-revealed');
        observer.unobserve(entries[i].target);
      }
    }, { threshold: 0.15 });

    scan(doc);
    root.classList.add('sy-motion');
    window.SutrayanReveal = { scan: scan };

    /* If a browser advertises IO but fails to deliver the first callback,
       reveal stuck above-fold items rather than disabling motion site-wide.
       Items with no client rect or inside a hidden ancestor (e.g. an inactive
       carousel slide) can never intersect, so they are not evidence of a
       failed observer and must be skipped. */
    window.setTimeout(function () {
      var viewportHeight = window.innerHeight || 800;
      var items = doc.querySelectorAll('[data-sy-reveal], .sy-reveal');
      /* perf: collect during the read pass, apply after — writing inside the
         loop forced a synchronous layout on every subsequent measurement. */
      var toReveal = [];
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        if (item.classList.contains('is-revealed')) continue;
        if (item.closest('[aria-hidden="true"], [hidden], .sy-hero__slide:not(.is-active)')) continue;
        var bounds = item.getBoundingClientRect();
        if (bounds.width === 0 && bounds.height === 0) continue;
        if (getComputedStyle(item).visibility === 'hidden') continue;
        if (bounds.top < viewportHeight && bounds.bottom > 0) {
          toReveal.push(item);
        }
      }
      for (var j = 0; j < toReveal.length; j++) {
        toReveal[j].classList.add('is-revealed');
      }
    }, 1600);

    doc.addEventListener('shopify:section:load', function (event) {
      scan(event.target);
    });
  } catch (error) {
    root.classList.remove('sy-motion');
  }
})();
